import { Link } from 'react-router-dom';
import { useState, FormEvent } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [subscribeError, setSubscribeError] = useState('');

  const handleSubscribe = async (e: FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubscribeStatus('loading');
    setSubscribeError('');

    try {
      const formData = new FormData(e.currentTarget);
      const honeypot = formData.get('website_alt') as string;
      if (honeypot && honeypot.trim()) {
        setSubscribeStatus('success');
        setEmail('');
        return;
      }

      const response = await fetch('http://pepmayans.com/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email }).toString(),
      });
      const responseText = await response.text();
      let serverMsg = '';
      try {
        const parsed = JSON.parse(responseText);
        serverMsg = parsed?.meta?.message || parsed?.message || '';
      } catch {
        serverMsg = responseText;
      }

      if (response.ok && !serverMsg.includes('spam')) {
        setSubscribeStatus('success');
        setEmail('');
      } else {
        setSubscribeStatus('error');
        setSubscribeError(serverMsg || '订阅失败，请稍后重试');
      }
    } catch {
      setSubscribeStatus('error');
      setSubscribeError('网络错误，请稍后重试');
    }
  };

  const footerLinks = [
    {
      title: '热门分类',
      links: [
        { label: '恋爱漫画', to: '/category/love' },
        { label: '热血动作', to: '/category/action' },
        { label: '奇幻冒险', to: '/category/fantasy' },
      ],
    },
    {
      title: '推荐漫画',
      links: [
        { label: '我独自升级', to: '/article/1' },
        { label: '女神降临', to: '/article/2' },
        { label: '全知读者视角', to: '/article/3' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '品牌介绍', to: '/about' },
        { label: '联系方式', to: '/about' },
        { label: '隐私政策', to: '/about' },
      ],
    },
    {
      title: '帮助中心',
      links: [
        { label: '常见问题', to: '/about' },
        { label: '用户协议', to: '/about' },
        { label: '版权声明', to: '/about' },
      ],
    },
  ];

  return (
    <footer className="bg-primary-800 text-background-50 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="w-full h-full" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='800' height='600' xmlns='http://pepmayans.com/2000/svg'%3E%3Cpath d='M100 200 Q150 150 200 200 T300 200 M400 100 Q450 50 500 100 T600 100 M200 400 Q250 350 300 400 T400 400 M500 350 Q550 300 600 350 T700 350' stroke='white' stroke-width='0.5' fill='none' opacity='0.3'/%3E%3Ccircle cx='150' cy='300' r='1' fill='white'/%3E%3Ccircle cx='450' cy='200' r='1.5' fill='white'/%3E%3Ccircle cx='350' cy='450' r='1' fill='white'/%3E%3Ccircle cx='600' cy='150' r='1' fill='white'/%3E%3Ccircle cx='250' cy='500' r='1.5' fill='white'/%3E%3C/svg%3E")`,
          backgroundSize: 'cover',
        }}></div>
      </div>

      <div className="relative z-10 px-6 md:px-10 py-14 md:py-18">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:w-[380px] shrink-0">
            <Link to="/" className="flex items-center gap-2 mb-6">
              <span className="font-heading text-xl md:text-2xl font-bold text-white tracking-tight">炮渣漫画</span>
              <span className="w-2 h-2 rounded-full bg-accent-500 mt-1"></span>
            </Link>

            <form onSubmit={handleSubscribe} className="mb-6">
              <div className="flex items-center gap-0">
                <div className="relative flex-1">
                  <input
                    type="text"
                    name="website_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="honeypot-field"
                  />
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="输入邮箱订阅更新"
                    required
                    className="w-full bg-transparent border border-background-50/20 text-white placeholder:text-background-50/40 text-sm px-4 py-3 rounded-lg focus:outline-none focus:border-accent-500 transition-colors"
                  />
                </div>
                <button
                  type="submit"
                  disabled={subscribeStatus === 'loading'}
                  className="bg-accent-500 hover:bg-accent-600 text-white w-11 h-11 flex items-center justify-center rounded-lg shrink-0 ml-2 cursor-pointer transition-colors"
                >
                  <i className={`text-lg ${subscribeStatus === 'loading' ? 'ri-loader-4-line animate-spin' : 'ri-notification-3-line'}`}></i>
                </button>
              </div>
              {subscribeStatus === 'success' && (
                <p className="text-accent-400 text-xs mt-2">订阅成功！感谢您的关注</p>
              )}
              {subscribeStatus === 'error' && (
                <p className="text-red-400 text-xs mt-2">{subscribeError}</p>
              )}
            </form>

            <p className="font-heading text-xl md:text-2xl text-white/90 leading-relaxed">
              每天更新<br />最新最热韩漫
            </p>
          </div>

          <div className="flex-1 grid grid-cols-2 sm:grid-cols-4 gap-8">
            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="text-sm font-semibold text-white mb-4">{group.title}</h4>
                <div className="flex flex-col gap-3">
                  {group.links.map((link) => (
                    <Link
                      key={link.label}
                      to={link.to}
                      className="text-sm text-background-50/60 hover:text-accent-400 transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/50">
            &copy; {new Date().getFullYear()} 炮渣漫画网 版权所有
          </p>
          <div className="flex items-center gap-4">
            {['ri-wechat-line', 'ri-weibo-line', 'ri-bilibili-line', 'ri-github-line'].map((icon) => (
              <a
                key={icon}
                href="#"
                rel="nofollow"
                className="w-9 h-9 flex items-center justify-center border border-background-50/15 rounded-lg text-background-50/60 hover:text-accent-400 hover:border-accent-400/40 transition-colors duration-200"
              >
                <i className={`${icon} text-sm`}></i>
              </a>
            ))}
          </div>
          <a href="#" className="text-xs text-background-50/50 hover:text-accent-400 transition-colors duration-200">
            隐私政策
          </a>
        </div>
      </div>
    </footer>
  );
}